export const findPixelByVendor = (trackers = [], provider = 'facebook') => {
  const needles = trackers.filter((tracker) => tracker.provider === provider)

  return needles
}
